<template>
  <div class="add-container" v-loading="formWorkOrderLoading">
    <el-page-header @back="goBack" content="工单详情" class="mb-10 fw-bold"> </el-page-header>
    <!-- 基本信息 -->
    <el-card class="box-card" shadow="never">
      <div slot="header" class="clearfix">
        <span class="fw-bold">基本信息</span>
        <el-tag :type="detail.baseData.status ? 'info' : ''" effect="dark" style="float: right;"> {{ detail.baseData.status === 1? '已关闭' : '处理中' }} </el-tag>
      </div>
      <el-form>
        <el-row>
          <el-col :span="12">
            <el-form-item label="工单编码："><span>{{detail.baseData.code}}</span></el-form-item>
            <el-form-item label="工单名称："><span>{{detail.baseData.name}}</span></el-form-item>
            <el-form-item label="触发问卷："><span>{{detail.baseData.formName}}</span></el-form-item>
            <el-form-item label="处理人："><span>{{detail.baseData.transactorName}}</span></el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="品牌："><span>{{detail.baseData.brandName}}</span></el-form-item>
            <el-form-item label="大区："><span>{{detail.baseData.parentPartitionName}}</span></el-form-item>
            <el-form-item label="分区："><span>{{detail.baseData.locatedPartitionName}}</span></el-form-item>
            <el-form-item label="门店："><span>{{detail.baseData.shopName}}</span></el-form-item>
            <el-form-item label="组织编码："><span>{{detail.baseData.shopCode}}</span></el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <!-- 触发内容 -->
    <el-card class="box-card" shadow="never">
      <div slot="header" class="clearfix">
        <span class="fw-bold">触发内容</span>
        <el-button style="float: right; padding: 3px 0" type="text" @click="handleClickToFormDetail">查看答卷详情 ></el-button>
      </div>
      <div v-html="detail.baseData.triggerReason"></div>
    </el-card>
    <!-- 工单日志 -->
    <el-card class="box-card" shadow="never">
      <div slot="header" class="clearfix">
        <span class="fw-bold">工单日志</span>
      </div>
      <el-table :data="detail.processingLogs">
        <el-table-column label="操作人" align="center" prop="transactorName" />
        <el-table-column label="操作类型" align="center" prop="operationType">
          <template slot-scope="{row}">
            <span>{{row.operationType | operationTypeToText}}</span>
          </template>
        </el-table-column>
        <el-table-column label="备注" align="center" prop="submessage"></el-table-column>
        <el-table-column label="操作时间" align="center" prop="createTime"></el-table-column>
      </el-table>
    </el-card>
    <div class="detail-footer" v-if="detail.baseData.status === 0">
      <el-button size="mini" type="primary" plain  @click="addRecord"> 添加处理记录 </el-button>
      <el-button size="mini" type="primary"  @click="openCloseOrderConfirm"> 关闭工单 </el-button>
    </div>
    <order-operator ref="recordForm" title="处理记录"  :closeOrderFormRule="recordFormRule" @handleConfirm="handleConfirmAddRecord"></order-operator>
    <order-operator ref="closeReasonForm" title="关闭工单" :closeOrderFormRule="closeOrderFormRule"  @handleConfirm="handleCloseOrderConfirm"></order-operator>

    <!-- 答卷详情 -->
    <ViewOrUpdate
      v-if="formModelItem.formData && formKey"
      ref="viewOrUpdateDialog"
      :fields="formModelItem.formFields"
      :fixed-fields="fixedFields"
      :form-key="formKey"
      :form-model="formModelItem.formData"
    />
  </div>
</template>

<script>
import OrderOperator from "./components/OrderOperator"
import { getWorkOrderDetail, submitRecord, handleBatchCloseWorkOrder } from '@/api/workOrder/list'
import { getFormDataDetailsRequest,   } from "@/api/project/data"
import { listFixedFormFieldsRequest } from '@/api/project/form'
import ViewOrUpdate  from "@/views/form/data/ViewOrUpdate.vue"
import { statusArr } from "../input"
export default {
  components: { OrderOperator, ViewOrUpdate },
  data(){
    return {
      detail:{
        baseData:{},
        processingLogs:[]
      },
      closeOrderFormRule:{
        content: [{required: true, message: '请输入关闭工单备注'}]
      },
      recordFormRule:{
        content: [{required: true, message: '请输入处理记录'}]
      },
      statusArr,
      formKey: '',
      formModelItem: {},
      fixedFields:{},
      formWorkOrderLoading: false,
      id: '',
    }
  },
  filters:{
    operationTypeToText(val) {
      let map = {
        0: "创建工单",
        1: "提交处理记录",
        2: "关闭工单"
      };
      return map[val];
    },
    statusToText(val) {
      return statusArr[val];
    },
  },
  created(){
    this.id = Number(this.$route.query.orderid)
    this.getDetail()
  },
  methods:{
    getDetail() {
      this.formWorkOrderLoading = true
      getWorkOrderDetail({id: this.$route.query.orderid}).then(res=>{
        const {data} = res
        this.formKey = data.baseData.formKey
        this.detail = data
        this.formWorkOrderLoading = false
      })
    },
    addRecord(){
      this.$refs.recordForm.operatorDialogOpen = true
    },
    openCloseOrderConfirm(){
      this.$refs.closeReasonForm.operatorDialogOpen = true
    },
    handleConfirmAddRecord(result){
      submitRecord({id: this.id, result}).then(res=>{
        this.$message.success("处理记录添加成功");
        this.$refs.recordForm.operatorDialogOpen = false
        this.getDetail()
      })
    },
    handleCloseOrderConfirm(closeResult){
      handleBatchCloseWorkOrder({ids: [this.id], closeResult}).then(res=>{
        this.$message.success("工单关闭成功");
        this.$refs.closeReasonForm.operatorDialogOpen = false
        this.getDetail()
      })
    },
    // 查看问卷详情
    async handleClickToFormDetail(){
      const res = await getFormDataDetailsRequest(this.detail.baseData.formDataId)
      this.formModelItem = res.data

        // 查询详情固定字段
      const {data} = await listFixedFormFieldsRequest(this.formKey)
      this.fixedFields = data
    
      this.$refs.viewOrUpdateDialog.showDialog()

    },
        /**
     * 检查按钮是否有权限
     * @param btn
     */
    checkBtnPerms(btn) {
      
      return true
    },
    goBack() {
      this.$router.replace('/workOrder/list')
    }
  }
}
</script>
<style scoped>
.add-container{
  padding: 20px;
  background: #fff;
  height: 100vh;
}
.box-card{
  width: 80%;
  margin-bottom: 20px;
  padding-bottom: 30px;
}
.detail-footer{
  width: 80%;
  text-align: center;
  margin-top: 40px;
}
</style>
